import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@base/environments/environment';
import { HttpService } from '@base/src/app/core/http.service';
import { firstValueFrom, Observable } from 'rxjs';

interface MovementsResumeResponse {
  cashResume: Record<string, string | number>;
}

@Injectable({
  providedIn: 'root',
})
export class MovementsService extends HttpService {
  constructor(public override http: HttpClient) {
    super(http);
    this.url = '/movement';
    this.baseUrl = environment.apiEndpoint;
  }

  getMovementsResume(
    agencyId: string,
    year: string,
    month: string,
    customCashflows: Record<string, boolean>
  ): Promise<MovementsResumeResponse> {
    return firstValueFrom(
      this.getMovementsResumeObservable(agencyId, year, month, customCashflows)
    );
  }

  getMovementsResumeObservable(
    agencyId: string,
    year: string,
    month: string,
    customCashflows: Record<string, boolean>
  ): Observable<MovementsResumeResponse> {
    const URL = `${this.baseUrl}${this.url}/${agencyId}/resume/${year}/${month}`;

    let params = new HttpParams();
    Object.keys(customCashflows).forEach((key) => {
      params = params.set(key, String(customCashflows[key]));
    });

    for (const KEY in customCashflows) {
      params = params.set(KEY, customCashflows[KEY]);
    }

    return this.http.get<MovementsResumeResponse>(URL, { params });
  }
}
